export type UserMessageSeverity = 'Error' | 'Warning' | 'Info'

export class UserMessage {
  id: string
  severity: UserMessageSeverity
  acl: any
  created_timestamp: string
  message: string

  constructor(data: UserMessage) {
    this.severity = data.severity
    this.acl = data.acl
    this.created_timestamp = data.created_timestamp
    this.message = data.message
    this.id = data.id
  }
}
